import { Typography, Grid, Box, Button } from "@mui/material";
import { Fragment } from "react";
import Bot from "../asset/bot.png";
import BannerBackground from "../asset/Banner Background.png";
// import NormalButton from "./trialButton/normalButton";
// import EastIcon from "@mui/icons-material/East";
import WhatsAppImg from "../asset/iphone.png";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { loginSelector } from "../redux/selectors/user.selector";
import CCTechLogo from "../asset/CCTech white.png";

function Home() {
  const theme = useTheme();
  const matches = useMediaQuery("(min-width:900px)");
  const matches2 = useMediaQuery("(max-width:825px)");
  const isLoggedIn = useSelector(loginSelector);

  return (
    <Fragment>
      <Grid
        container
        display="flex"
        justifyContent="center"
        alignItems={"center"}
        style={{
          margin: "30px 0 30px 0",
          padding: matches ? "0 100px" : "0 20px",
          position: "relative", // Set position to relative for the parent container
        }}
      >
        <Grid
          item
          xs={12}
          md={matches || matches2 ? 6 : 12}
          sm={12}
          style={{
            textAlign: "center",
            // padding: "50px 200px",
            padding: matches ? "0 100px" : "0 20px",
          }}
        >
          <Typography
            variant="h4"
            style={{
              color: `${theme.palette.primary.main}`,
              fontWeight: 500,
            }}
          >
            Your WhatsApp AI Assistant for ACC
          </Typography>
          <Typography
            variant="h6"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span>Product by </span>&nbsp;&nbsp;
            <img src={CCTechLogo} alt="cctech logo" width={60} />
          </Typography>
          <br />
          <Typography style={{ fontSize: "16px" }}>
            Unlock the full potential of Autodesk Construction Cloud with your
            AI collaborator, the Copilot that redefines construction project
            management.
          </Typography>
          <Box
            mt={4}
            display="flex"
            justifyContent={matches ? "flex-start" : "center"}
            flexDirection={"row"}
            alignItems={"center"}
          >
            <img
              src={Bot}
              alt="qr to whatsapp"
              width={matches ? 300 : 200}
              height={matches ? 300 : 200}
              style={{ position: "relative", left: matches ? "-60px" : 0 }}
            />
            {!isLoggedIn && (
              <Link to="/sign-up">
                <Button variant="outlined" size="large">
                  Start a free trial
                </Button>
              </Link>
            )}
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={matches || matches2 ? 6 : 12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "flex-start", // Align items to the top
            justifyContent: "flex-end",
          }}
        >
          <img
            src={BannerBackground}
            alt="qr to whatsapp"
            style={{
              position: "absolute",
              top: "-125px",
              right: "0",
              width: "680px",
              display: matches2 ? "none" : "block",
              maxWidth: "680px",
              zIndex: "-2",
            }}
          />
          <div className="image-container">
            <img
              src={WhatsAppImg}
              alt="productimage"
              height={matches ? 600 : 500}
              className="image"
              style={{
                position: "relative",
                right: matches2 ? "60px" : "200px",
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default Home;
